module.exports = __webpack_public_path__ + "img/image_case_2.e0ecb7ec.png";